import {Dispatcher} from 'flux';


/**
 * Constraint:
 * All Stores from the same group must use the same dispatcher
 */

export default new Dispatcher();



// WEBPACK FOOTER //
// ./src/data/Dispatcher.js